/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminsRouteImport } from './routes/admins'
import { Route as AiUsageRouteImport } from './routes/ai-usage'
import { Route as AuditLogRouteImport } from './routes/audit-log'
import { Route as BillingIndexRouteImport } from './routes/billing/index'
import { Route as BillingPlansRouteImport } from './routes/billing/plans'
import { Route as BillingSettingsRouteImport } from './routes/billing/settings'
import { Route as RestaurantsIndexRouteImport } from './routes/restaurants/index'
import { Route as RestaurantsRestaurantIdRouteImport } from './routes/restaurants/$restaurantId'
import { Route as RestaurantsNewRouteImport } from './routes/restaurants/new'
import { Route as RestaurantsRestaurantIdDescriptionsRouteImport } from './routes/restaurants/$restaurantId_.descriptions'
import { Route as RestaurantsRestaurantIdImagesRouteImport } from './routes/restaurants/$restaurantId_.images'
import { Route as RestaurantsRestaurantIdMenuImportRouteImport } from './routes/restaurants/$restaurantId_.menu-import'
import { Route as RestaurantsRestaurantIdSiteRouteImport } from './routes/restaurants/$restaurantId_.site'
import { Route as RestaurantsRestaurantIdSubscriptionRouteImport } from './routes/restaurants/$restaurantId_.subscription'
import { Route as RestaurantsRestaurantIdMenuImportImportIdRouteImport } from './routes/restaurants/$restaurantId_.menu-import_.$importId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminsRoute = AdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => rootRouteImport,
} as any)
const AiUsageRoute = AiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogRoute = AuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingIndexRoute = BillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingPlansRoute = BillingPlansRouteImport.update({
  id: '/billing/plans',
  path: '/billing/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingSettingsRoute = BillingSettingsRouteImport.update({
  id: '/billing/settings',
  path: '/billing/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RestaurantsIndexRoute = RestaurantsIndexRouteImport.update({
  id: '/restaurants/',
  path: '/restaurants/',
  getParentRoute: () => rootRouteImport,
} as any)
const RestaurantsRestaurantIdRoute = RestaurantsRestaurantIdRouteImport.update({
  id: '/restaurants/$restaurantId',
  path: '/restaurants/$restaurantId',
  getParentRoute: () => rootRouteImport,
} as any)
const RestaurantsNewRoute = RestaurantsNewRouteImport.update({
  id: '/restaurants/new',
  path: '/restaurants/new',
  getParentRoute: () => rootRouteImport,
} as any)
const RestaurantsRestaurantIdDescriptionsRoute =
  RestaurantsRestaurantIdDescriptionsRouteImport.update({
    id: '/restaurants/$restaurantId_/descriptions',
    path: '/restaurants/$restaurantId/descriptions',
    getParentRoute: () => rootRouteImport,
  } as any)
const RestaurantsRestaurantIdImagesRoute =
  RestaurantsRestaurantIdImagesRouteImport.update({
    id: '/restaurants/$restaurantId_/images',
    path: '/restaurants/$restaurantId/images',
    getParentRoute: () => rootRouteImport,
  } as any)
const RestaurantsRestaurantIdMenuImportRoute =
  RestaurantsRestaurantIdMenuImportRouteImport.update({
    id: '/restaurants/$restaurantId_/menu-import',
    path: '/restaurants/$restaurantId/menu-import',
    getParentRoute: () => rootRouteImport,
  } as any)
const RestaurantsRestaurantIdSiteRoute =
  RestaurantsRestaurantIdSiteRouteImport.update({
    id: '/restaurants/$restaurantId_/site',
    path: '/restaurants/$restaurantId/site',
    getParentRoute: () => rootRouteImport,
  } as any)
const RestaurantsRestaurantIdSubscriptionRoute =
  RestaurantsRestaurantIdSubscriptionRouteImport.update({
    id: '/restaurants/$restaurantId_/subscription',
    path: '/restaurants/$restaurantId/subscription',
    getParentRoute: () => rootRouteImport,
  } as any)
const RestaurantsRestaurantIdMenuImportImportIdRoute =
  RestaurantsRestaurantIdMenuImportImportIdRouteImport.update({
    id: '/restaurants/$restaurantId_/menu-import_/$importId',
    path: '/restaurants/$restaurantId/menu-import/$importId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admins': typeof AdminsRoute
  '/ai-usage': typeof AiUsageRoute
  '/audit-log': typeof AuditLogRoute
  '/billing/plans': typeof BillingPlansRoute
  '/billing/settings': typeof BillingSettingsRoute
  '/restaurants/$restaurantId': typeof RestaurantsRestaurantIdRoute
  '/restaurants/new': typeof RestaurantsNewRoute
  '/billing/': typeof BillingIndexRoute
  '/restaurants/': typeof RestaurantsIndexRoute
  '/restaurants/$restaurantId/descriptions': typeof RestaurantsRestaurantIdDescriptionsRoute
  '/restaurants/$restaurantId/images': typeof RestaurantsRestaurantIdImagesRoute
  '/restaurants/$restaurantId/menu-import': typeof RestaurantsRestaurantIdMenuImportRoute
  '/restaurants/$restaurantId/site': typeof RestaurantsRestaurantIdSiteRoute
  '/restaurants/$restaurantId/subscription': typeof RestaurantsRestaurantIdSubscriptionRoute
  '/restaurants/$restaurantId/menu-import/$importId': typeof RestaurantsRestaurantIdMenuImportImportIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admins': typeof AdminsRoute
  '/ai-usage': typeof AiUsageRoute
  '/audit-log': typeof AuditLogRoute
  '/billing/plans': typeof BillingPlansRoute
  '/billing/settings': typeof BillingSettingsRoute
  '/restaurants/$restaurantId': typeof RestaurantsRestaurantIdRoute
  '/restaurants/new': typeof RestaurantsNewRoute
  '/billing': typeof BillingIndexRoute
  '/restaurants': typeof RestaurantsIndexRoute
  '/restaurants/$restaurantId/descriptions': typeof RestaurantsRestaurantIdDescriptionsRoute
  '/restaurants/$restaurantId/images': typeof RestaurantsRestaurantIdImagesRoute
  '/restaurants/$restaurantId/menu-import': typeof RestaurantsRestaurantIdMenuImportRoute
  '/restaurants/$restaurantId/site': typeof RestaurantsRestaurantIdSiteRoute
  '/restaurants/$restaurantId/subscription': typeof RestaurantsRestaurantIdSubscriptionRoute
  '/restaurants/$restaurantId/menu-import/$importId': typeof RestaurantsRestaurantIdMenuImportImportIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admins': typeof AdminsRoute
  '/ai-usage': typeof AiUsageRoute
  '/audit-log': typeof AuditLogRoute
  '/billing/plans': typeof BillingPlansRoute
  '/billing/settings': typeof BillingSettingsRoute
  '/restaurants/$restaurantId': typeof RestaurantsRestaurantIdRoute
  '/restaurants/new': typeof RestaurantsNewRoute
  '/billing/': typeof BillingIndexRoute
  '/restaurants/': typeof RestaurantsIndexRoute
  '/restaurants/$restaurantId_/descriptions': typeof RestaurantsRestaurantIdDescriptionsRoute
  '/restaurants/$restaurantId_/images': typeof RestaurantsRestaurantIdImagesRoute
  '/restaurants/$restaurantId_/menu-import': typeof RestaurantsRestaurantIdMenuImportRoute
  '/restaurants/$restaurantId_/site': typeof RestaurantsRestaurantIdSiteRoute
  '/restaurants/$restaurantId_/subscription': typeof RestaurantsRestaurantIdSubscriptionRoute
  '/restaurants/$restaurantId_/menu-import_/$importId': typeof RestaurantsRestaurantIdMenuImportImportIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admins'
    | '/ai-usage'
    | '/audit-log'
    | '/billing/plans'
    | '/billing/settings'
    | '/restaurants/$restaurantId'
    | '/restaurants/new'
    | '/billing/'
    | '/restaurants/'
    | '/restaurants/$restaurantId/descriptions'
    | '/restaurants/$restaurantId/images'
    | '/restaurants/$restaurantId/menu-import'
    | '/restaurants/$restaurantId/site'
    | '/restaurants/$restaurantId/subscription'
    | '/restaurants/$restaurantId/menu-import/$importId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admins'
    | '/ai-usage'
    | '/audit-log'
    | '/billing/plans'
    | '/billing/settings'
    | '/restaurants/$restaurantId'
    | '/restaurants/new'
    | '/billing'
    | '/restaurants'
    | '/restaurants/$restaurantId/descriptions'
    | '/restaurants/$restaurantId/images'
    | '/restaurants/$restaurantId/menu-import'
    | '/restaurants/$restaurantId/site'
    | '/restaurants/$restaurantId/subscription'
    | '/restaurants/$restaurantId/menu-import/$importId'
  id:
    | '__root__'
    | '/'
    | '/admins'
    | '/ai-usage'
    | '/audit-log'
    | '/billing/plans'
    | '/billing/settings'
    | '/restaurants/$restaurantId'
    | '/restaurants/new'
    | '/billing/'
    | '/restaurants/'
    | '/restaurants/$restaurantId_/descriptions'
    | '/restaurants/$restaurantId_/images'
    | '/restaurants/$restaurantId_/menu-import'
    | '/restaurants/$restaurantId_/site'
    | '/restaurants/$restaurantId_/subscription'
    | '/restaurants/$restaurantId_/menu-import_/$importId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminsRoute: typeof AdminsRoute
  AiUsageRoute: typeof AiUsageRoute
  AuditLogRoute: typeof AuditLogRoute
  BillingPlansRoute: typeof BillingPlansRoute
  BillingSettingsRoute: typeof BillingSettingsRoute
  RestaurantsRestaurantIdRoute: typeof RestaurantsRestaurantIdRoute
  RestaurantsNewRoute: typeof RestaurantsNewRoute
  BillingIndexRoute: typeof BillingIndexRoute
  RestaurantsIndexRoute: typeof RestaurantsIndexRoute
  RestaurantsRestaurantIdDescriptionsRoute: typeof RestaurantsRestaurantIdDescriptionsRoute
  RestaurantsRestaurantIdImagesRoute: typeof RestaurantsRestaurantIdImagesRoute
  RestaurantsRestaurantIdMenuImportRoute: typeof RestaurantsRestaurantIdMenuImportRoute
  RestaurantsRestaurantIdSiteRoute: typeof RestaurantsRestaurantIdSiteRoute
  RestaurantsRestaurantIdSubscriptionRoute: typeof RestaurantsRestaurantIdSubscriptionRoute
  RestaurantsRestaurantIdMenuImportImportIdRoute: typeof RestaurantsRestaurantIdMenuImportImportIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admins': {
      id: '/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AdminsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-usage': {
      id: '/ai-usage'
      path: '/ai-usage'
      fullPath: '/ai-usage'
      preLoaderRoute: typeof AiUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-log': {
      id: '/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/': {
      id: '/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof BillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/plans': {
      id: '/billing/plans'
      path: '/billing/plans'
      fullPath: '/billing/plans'
      preLoaderRoute: typeof BillingPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/settings': {
      id: '/billing/settings'
      path: '/billing/settings'
      fullPath: '/billing/settings'
      preLoaderRoute: typeof BillingSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/': {
      id: '/restaurants/'
      path: '/restaurants'
      fullPath: '/restaurants/'
      preLoaderRoute: typeof RestaurantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/$restaurantId': {
      id: '/restaurants/$restaurantId'
      path: '/restaurants/$restaurantId'
      fullPath: '/restaurants/$restaurantId'
      preLoaderRoute: typeof RestaurantsRestaurantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/new': {
      id: '/restaurants/new'
      path: '/restaurants/new'
      fullPath: '/restaurants/new'
      preLoaderRoute: typeof RestaurantsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/$restaurantId_/descriptions': {
      id: '/restaurants/$restaurantId_/descriptions'
      path: '/restaurants/$restaurantId/descriptions'
      fullPath: '/restaurants/$restaurantId/descriptions'
      preLoaderRoute: typeof RestaurantsRestaurantIdDescriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/$restaurantId_/images': {
      id: '/restaurants/$restaurantId_/images'
      path: '/restaurants/$restaurantId/images'
      fullPath: '/restaurants/$restaurantId/images'
      preLoaderRoute: typeof RestaurantsRestaurantIdImagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/$restaurantId_/menu-import': {
      id: '/restaurants/$restaurantId_/menu-import'
      path: '/restaurants/$restaurantId/menu-import'
      fullPath: '/restaurants/$restaurantId/menu-import'
      preLoaderRoute: typeof RestaurantsRestaurantIdMenuImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/$restaurantId_/site': {
      id: '/restaurants/$restaurantId_/site'
      path: '/restaurants/$restaurantId/site'
      fullPath: '/restaurants/$restaurantId/site'
      preLoaderRoute: typeof RestaurantsRestaurantIdSiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/$restaurantId_/subscription': {
      id: '/restaurants/$restaurantId_/subscription'
      path: '/restaurants/$restaurantId/subscription'
      fullPath: '/restaurants/$restaurantId/subscription'
      preLoaderRoute: typeof RestaurantsRestaurantIdSubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restaurants/$restaurantId_/menu-import_/$importId': {
      id: '/restaurants/$restaurantId_/menu-import_/$importId'
      path: '/restaurants/$restaurantId/menu-import/$importId'
      fullPath: '/restaurants/$restaurantId/menu-import/$importId'
      preLoaderRoute: typeof RestaurantsRestaurantIdMenuImportImportIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminsRoute: AdminsRoute,
  AiUsageRoute: AiUsageRoute,
  AuditLogRoute: AuditLogRoute,
  BillingPlansRoute: BillingPlansRoute,
  BillingSettingsRoute: BillingSettingsRoute,
  RestaurantsRestaurantIdRoute: RestaurantsRestaurantIdRoute,
  RestaurantsNewRoute: RestaurantsNewRoute,
  BillingIndexRoute: BillingIndexRoute,
  RestaurantsIndexRoute: RestaurantsIndexRoute,
  RestaurantsRestaurantIdDescriptionsRoute:
    RestaurantsRestaurantIdDescriptionsRoute,
  RestaurantsRestaurantIdImagesRoute: RestaurantsRestaurantIdImagesRoute,
  RestaurantsRestaurantIdMenuImportRoute:
    RestaurantsRestaurantIdMenuImportRoute,
  RestaurantsRestaurantIdSiteRoute: RestaurantsRestaurantIdSiteRoute,
  RestaurantsRestaurantIdSubscriptionRoute:
    RestaurantsRestaurantIdSubscriptionRoute,
  RestaurantsRestaurantIdMenuImportImportIdRoute:
    RestaurantsRestaurantIdMenuImportImportIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
